import { __decorate } from "tslib";
import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import { throttle } from 'helpful-decorators';
export default class ProductUsps {
    static $element = $('.js__product-usps');
    static $pin = $('.js__product-usps-pin');
    static $progressBars = $('.js__product-usps-progress-bar');
    static $scenes = $('.js__product-usps-scene');
    static scene;
    static currentScene;
    static currentVideo;
    static isSceneEntered = false;
    static init() {
        if (!this.$element.length) {
            return;
        }
        const controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 'onLeave',
                duration: `${this.$scenes.length * 100}%`,
            },
        });
        this.scene = new ScrollMagic.Scene({
            triggerElement: this.$element.get(0),
        })
            .setPin(this.$pin.get(0))
            .addTo(controller);
        this.scene.on('enter', (event) => {
            const nextScene = this.getCurrentSceneByProgress(event.progress);
            if (event.progress < 1) {
                this.isSceneEntered = true;
                this.sceneChange(nextScene);
            }
        });
        this.scene.on('leave', () => {
            this.isSceneEntered = false;
        });
        this.scene.on('progress', (event) => {
            const nextScene = this.getCurrentSceneByProgress(event.progress);
            if (this.currentScene !== nextScene) {
                this.sceneChange(nextScene);
            }
        });
        this.scene.on('update', (event) => {
            this.scene.off('update', undefined);
            this.currentScene = event.scrollPos > event.endPos ? this.$scenes.length - 1 : 0;
            this.currentVideo = this.getCurrentVideo();
            this.currentVideo.load();
            this.sceneChange(this.currentScene);
        });
        $(window).on('resize', this.handleResize.bind(this));
    }
    static sceneChange(nextScene) {
        this.currentScene = nextScene;
        this.$scenes.removeClass('active').eq(this.currentScene).addClass('active');
        this.$progressBars
            .removeClass('active')
            .slice(0, this.currentScene + 1)
            .addClass('active');
        if (this.isSceneEntered) {
            this.playVideo();
        }
    }
    static playVideo() {
        const previousVideo = this.currentVideo;
        const currentVideo = this.getCurrentVideo();
        if (previousVideo !== currentVideo) {
            // Waits for previous scene to fade out
            setTimeout(() => {
                // Pauses and resets previous video
                previousVideo.pause();
                previousVideo.load();
            }, 500);
        }
        // Plays current video
        this.currentVideo = currentVideo;
        this.currentVideo.play();
    }
    static getCurrentSceneByProgress(progress) {
        return Math.min(Math.floor(progress * this.$scenes.length), this.$scenes.length - 1);
    }
    static getCurrentVideo() {
        return this.$scenes.eq(this.currentScene).find('.js__product-usps-video:visible').get(0);
    }
    static handleResize() {
        if (this.isSceneEntered && this.currentVideo !== this.getCurrentVideo()) {
            this.playVideo();
        }
    }
}
__decorate([
    throttle(300)
], ProductUsps, "handleResize", null);
